import { css as o } from "@microsoft/fast-element";
import { normalize as r } from "../../common/normalize.js";
import { display as m } from "@matrix42/fast-foundation";
const p = o`
  ${r}
  ${m("block")}
`;
export {
  p as tabPanelStyles
};
